
import React from "react";
import { Search } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface AdSearchProps {
  searchName: string;
  setSearchName: (value: string) => void;
  searchDate: string;
  setSearchDate: (value: string) => void;
  handleSearch: () => void;
  clearSearch: () => void;
  isSearching: boolean;
}

const AdSearch: React.FC<AdSearchProps> = ({
  searchName,
  setSearchName,
  searchDate,
  setSearchDate,
  handleSearch,
  clearSearch,
  isSearching
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-xl">Buscar Anuncios</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-4 md:flex-row">
          <div className="flex-1 space-y-2">
            <Label htmlFor="search-name">Nombre del anuncio</Label>
            <Input 
              id="search-name"
              placeholder="Nombre del cliente o anuncio"
              value={searchName}
              onChange={(e) => setSearchName(e.target.value)}
            />
          </div>
          <div className="flex-1 space-y-2">
            <Label htmlFor="search-date">Fecha de inicio</Label>
            <Input 
              id="search-date"
              type="date"
              value={searchDate}
              onChange={(e) => setSearchDate(e.target.value)}
            />
          </div>
          <div className="flex items-end space-x-2">
            <Button onClick={handleSearch} disabled={isSearching}>
              <Search className="mr-2 h-4 w-4" />
              {isSearching ? "Buscando..." : "Buscar"}
            </Button>
            <Button variant="outline" onClick={clearSearch} disabled={isSearching}>
              Limpiar
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default AdSearch;
